import { useEffect, useState } from "react";
import {
  MiBox,
  MiBuildPageHeader,
  MiIcon,
  MiList,
} from "@miplatform/components";
import { PAGINATION } from "@miplatform/constants";
import { useDebounce, useRouter } from "@miplatform/hooks";
import { AccountType, IAccountListResponse } from "@miplatform/types";
import { mdiHexagonOutline } from "@mdi/js";
import { useAccounts } from "@mibuildweb/hooks";
import { useTheme } from "@mui/material";
import { SectionInfo } from "../../components/SectionInfo/SectionInfo";
import { useSeriesCountsViewModel } from "./useSeriesCountsViewModel";

export function Series() {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search);

  const theme = useTheme();
  const { navigate } = useRouter();
  const { isLoading, accounts, getAccounts } = useAccounts({
    accountTypes: [AccountType.Builder],
  });
  const { countsByAccountId, getSeriesCounts } = useSeriesCountsViewModel();

  useEffect(() => {
    if (accounts.length) {
      getSeriesCounts(accounts.map((account) => account.id));
    }
  }, [accounts]);

  const sections = [
    {
      fieldset: [
        {
          renderValue: (data: IAccountListResponse) => {
            const counts = countsByAccountId[data.id];
            return (
              <SectionInfo
                data={{
                  ...data,
                  additionalTitleText: [
                    `Series Groups: ${counts?.seriesGroupCount ?? 0}`,
                    `Series: ${counts?.seriesCount ?? 0}`,
                  ],
                }}
              />
            );
          },
        },
      ],
    },
  ];

  const handleNavigate = (item: IAccountListResponse) => {
    if (item.id) {
      navigate(`/estimating/pricing/series/${item.id}`);
    }
  };

  return (
    <>
      <MiBuildPageHeader
        title="Series"
        loading={isLoading}
        search={search}
        onHandleSearch={(e: React.ChangeEvent<HTMLInputElement>) =>
          setSearch(e.target.value)
        }
        titleIcon={
          <MiIcon path={mdiHexagonOutline} color={theme.palette.primary.main} />
        }
        actionContainerStyle={{
          flexWrap: "nowrap",
        }}
      />
      <MiBox>
        <MiList
          viewType="card"
          data={accounts}
          loading={isLoading}
          dataProvider={getAccounts}
          search={debouncedSearch}
          cardProps={{
            sections,
            onClick: handleNavigate,
          }}
          paginationMode={PAGINATION.SERVER}
          emptyListProps={{
            text: "No records found",
          }}
          data-testid="series-list"
        />
      </MiBox>
    </>
  );
}
